import { AxiosRequestConfig } from 'axios';
import _ from 'lodash';
import { useMutation, UseMutationOptions, UseMutationResult } from 'react-query';
import { Envs, useBaseUrl, useEnvContext } from 'scbk-services/config';
import { RequestType } from 'scbk-services/http/constants';
import { BsoiService } from 'scbk-services/http/services/bsoi-service';
import { CustomAxiosRequestConfig } from 'scbk-services/types/http/axios-extension';
import { BSOIError } from 'scbk-services/types/http/bsoi-error';

/**
 * useBsoi Hook Options
 *
 */
export interface UseBsoiPostOptions extends AxiosRequestConfig {
    baseUrl?: string;
    endpoint: string;
}

/**
 *
 */
export interface UseBsoiPostMutationOptions<TParams, TData>
    extends UseMutationOptions<TData, BSOIError.Error, TParams, unknown> {
    skipLoading?: boolean;
}

/**
 * BSOI Post 요청 Hook
 */
const useBsoiPost = <TParams, TData>(
    options: UseBsoiPostOptions,
    mutationOptions?: UseBsoiPostMutationOptions<TParams, TData>,
): UseMutationResult<TData, BSOIError.Error, TParams, unknown> => {
    const { baseUrl, endpoint, ...config } = options;
    const { getEnv } = useEnvContext();
    const { getBsoiBaseUrl } = useBaseUrl();
    const contextBaseUrl = getBsoiBaseUrl(getEnv() === Envs.MOCK);
    const targetUrl = _.isEmpty(baseUrl) ? contextBaseUrl : baseUrl;

    const asyncFun = async (variables: TParams) => {
        return new BsoiService(targetUrl as string).post<TData>(endpoint, variables, {
            ...config,
            customBaseUrl: targetUrl,
            requestType: RequestType.BSOI,
        } as CustomAxiosRequestConfig);
    };

    return useMutation<TData, BSOIError.Error, TParams, unknown>(asyncFun, {
        retry: false,
        ...mutationOptions,
    } as UseMutationOptions<TData, unknown, TParams, unknown>);
};

export default useBsoiPost;
